import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/compras-legado/ComprasLegadoApiClient'

export default {
	async [actionTypes.COMPRAS_LEGADO.BUSCAR_URL_ATA_RP](context, header) {
		const { data } = await api.buscarUrl(header)
		return data
	},
}
